import { render } from "./GeneratedRain.vue?vue&type=template&id=3f70dcb1"
import script from "./GeneratedRain.vue?vue&type=script&lang=js"
export * from "./GeneratedRain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__